export default ($el) => {
  $el.find('.close').on('click', () => {
    $el.addClass('hidden');
  });
};
